export default {"src":"/_next/static/media/first.33dfe93c.svg","height":378,"width":631,"blurWidth":0,"blurHeight":0};